export const PRICE_CHANGE_VARIANT = {
    DROP: 'drop',
    INCREASE: 'increase'
} as const
export type PriceChangeVariant = (typeof PRICE_CHANGE_VARIANT)[keyof typeof PRICE_CHANGE_VARIANT]

export const INTERSTITIAL_ALERT_TYPE = {
    PRICE_DROP: 'priceDrop',
    PRICE_INCREASE: 'priceIncrease',
    FLIGHT_UNAVAILABLE: 'flightUnavailable'
} as const
export type InterstitialAlertType = (typeof INTERSTITIAL_ALERT_TYPE)[keyof typeof INTERSTITIAL_ALERT_TYPE]

export const INTERSTITIAL_ALERT_QUERY_PARAM = 'interstitialAlert'

export const PRICE_CHANGE_ICON_COLORS: Record<PriceChangeVariant, { background: string; stroke: string }> = {
    [PRICE_CHANGE_VARIANT.DROP]: { background: '#ECF8F4', stroke: '#11A056' },
    [PRICE_CHANGE_VARIANT.INCREASE]: { background: '#FBEFEF', stroke: '#C83232' }
}

export const FLIGHT_UNAVAILABLE_ICON_COLORS = { background: '#FBEFEF', stroke: '#CD1719' }

export const PRICE_CHANGE_ALERT_TITLE: Record<PriceChangeVariant, string> = {
    [PRICE_CHANGE_VARIANT.DROP]: 'Great news! Flight prices just dropped',
    [PRICE_CHANGE_VARIANT.INCREASE]: 'Your flight prices have updated'
}

export const NEW_FLIGHT_PRICE_LABEL = 'New flight price:'
export const ACCEPT_NEW_FARE_CTA = 'Accept new fare'
export const FIND_ANOTHER_FLIGHT_CTA = 'Find another flight'

export const FLIGHT_UNAVAILABLE_TITLE = 'The flight you were looking at is no longer available.'
export const FLIGHT_UNAVAILABLE_SUBTITLE = 'Please select an alternate flight.'
